import React from 'react';
import { ContentComponentProps } from '../../../utils/pageBuilder/types';

export function PageBuilderGeneric({
  children,
  htmlTag,
  contentType,
  'data-pb-style': styleId
}: ContentComponentProps) {
  const Component = (htmlTag || 'div') as React.ElementType;

  return (
    <Component
      className={contentType}
      data-content={contentType}
      data-pb-style={styleId as string | undefined}
    >
      {children}
    </Component>
  );
}
